/**
 * メールリンクログイン（mode=signIn）を /auth/action で受けずに continueUrl へ素通しする。
 *
 * アクション URL は Firebase プロジェクト単位の設定なので、自前ページへ切り替えると
 * verifyEmail 等と一緒に signIn も /auth/action へ来る。ここでガードの
 * `isSignInWithEmailLink` 受領（router.js）より先に転送しておくことで、
 * メールリンクログインの経路を従来のまま（continueUrl 側で受領）に保つ。
 */
import {
  AUTH_ACTION_PATH,
  emailLinkSignInForwardUrl,
  queryValue
} from '@/utils/auth/authAction'

type ForwardEmailLinkSignInInput = {
  path: string
  query: Record<string, unknown>
  siteUrl: string
  allowedOrigins: string[]
}

/** 転送したら true。呼び出し側はルーティングを中断する。 */
export function forwardEmailLinkSignIn(
  input: ForwardEmailLinkSignInInput
): boolean {
  if (input.path !== AUTH_ACTION_PATH) return false
  if (queryValue(input.query.mode) !== 'signIn') return false
  if (!queryValue(input.query.oobCode)) return false

  const forwardUrl = emailLinkSignInForwardUrl(
    input.query,
    window.location.origin,
    input.siteUrl,
    input.allowedOrigins
  )
  window.location.replace(forwardUrl)
  return true
}
